<template>
  <div class="product-card">
    <div class="image-frame"><img :src="data.image"></div>
    <div class="discount" v-show="showDiscount">{{ showDiscount }}</div>
    <h3 class="title">{{ data.title }}</h3>
    <div class="price-box">
      <p class="price" v-show="data.price && data.price != data.sale">${{ data.price }}</p>
      <p class="sale">${{ data.sale }}</p>
    </div>
    <a href="#" @click="viewDetailsProduct" class="go-btn">Ver +</a>
  </div>
</template>
<script>
/* eslint-disable */
export default {
  name: 'Product',
  props: {
    data: Object,
    word: String
  },
  computed: {
    showDiscount () {
      if (this.data.discount) {
        let discount = this.data.discount.toLowerCase()
        switch (this.data.discount) {
          case 'superprecio':
            discount = 'SUPER\nPRECIO'
            break
          case '4x3':
          case '2x1':
          case '6x4':
          case '3x2':
            break
          default:
            discount = discount + '%'
            break
        }
        return discount
      } else {
        return null
      }
    }
  },
  methods: {
    viewDetailsProduct (ev) {
      ev.preventDefault()
      ev.stopPropagation()
      dataLayer.push({
          'event': 'Interacción', // Acá se deja como evento de interacción
          'category': 'Buscador', // Detallar que se realizó un evento con el buscador
          'action': 'Búsqueda: '+this.word, // Hay que registrar qué es lo que se buscó al hacer clic
          'tag': this.data.title // Nombre del producto o link de imagen del banner asociado  
      });
      this.$parent.$parent.openDetail(this.data.sku)
    }
  },
  data () {
    return {
      test: 'Test'
    }
  }
}
</script>
<style>
  .item-list {height:385px;}
  .product-card {height:385px;position:relative;}
  .item-container,.image-frame { width: 100%; }
  .image-frame { width:100%;border:solid thin #ebebeb; }
  .image-frame img{ width:100%; }
  .title { font-family: 'Open Sans', sans-serif;font-size: 1.250em;line-height:1.150em;text-align: left;font-weight: 600;margin-bottom:10px;max-height:69px;overflow:hidden;}
  .discount { width:40px;height:40px;background-color:#000;line-height:42px;color:#fff;border-radius:20px;position:absolute;top:5px;left:5px }
  .price-box{position:absolute;bottom:30px;}
  .price,.sale { margin:0px;text-align:left }
  .price { text-decoration:line-through;color:#000;font-size:1em;letter-spacing:1px; }
  .sale { font-weight: 400;color:#E0172F;font-size:1.500em;letter-spacing:1px;margin-bottom:10px; }
  .go-btn { color: #fff;background-color: #E0172F;display: block;width: 100%;margin: 5px auto;padding: 3px 0px;text-decoration: none;border-radius:5px;position:absolute;bottom:0px; }
  @media only screen and (min-width: 1000px) {
    .item-list {height:45vh;vertical-align: top;}
    .product-card {height:45vh;position:relative;}
    .title{font-size: 14px;line-height: 16px;padding-bottom: 10px;font-weight: 400;}
    .image-frame { width:200px;border:solid thin #ebebeb; }
    .image-frame img {width: auto;max-height: 19vh;}
    .price {font-size:14px; color:#666}
    .sale { font-weight: 400;color:#E0172F;font-size:18px;margin-bottom:15px}
  }
  @media only screen and (min-width: 1400px) {
    .title{font-size: 18px;line-height: 20px;padding-bottom: 15px;font-weight: 400;}
    .price {font-size:14px; color:#666}
    .sale { font-weight: 400;color:#E0172F;font-size:18px;margin-bottom:15px}
  }
</style>



// WEBPACK FOOTER //
// src/components/ProductSearchComponent.vue